// extracted by mini-css-extract-plugin
module.exports = {"listItem":"list-item_listItem__De24R"};